export default "__VITE_ASSET__HjjCPyFf__"